<script>
	import MainTitle from '../atoms/MainTitle.svelte';
	import AllMedia from '../organisms/AllMedia.svelte';
	import { store } from '../store';
	import { SendDataToPhp } from '../service';
	import { getPhpFolderPath, getConnectorValue } from '../query';
	import SendMediaForm from '../molecules/SendMediaForm.svelte';
	import LoadFile from '../molecules/LoadFile.svelte';

	export let params = {};
	let data = [];
	data.media = [];
	let isConnected = getConnectorValue();
	let isLoadData = false;
	let currentNbFile = 0;

	store.subscribe((value) => {
		if (value.portfolio !== undefined) {
			data = value.portfolio.filter((obj) => {
				return obj.id === params.id;
			})[0];
		}
	});

	function SendFile() {
		let formData = new FormData();
		let files = document.getElementById('file').files;
		for (let i = 0; i < files.length; i++) {
			let fileRename = changeFileName(files[i], i);
			formData.append(i, fileRename);
			formData.append('idPortfolio', params.id);
			formData.append('pos', data.media.length + 1);
		}

		if (files.length > 0 && files.length <= 5) {
			SendDataToPhp(getPhpFolderPath() + 'uploadFile.php', formData, 'protfolio', false);
			isLoadData = true;
		}

		if (files.length > 5) {
			alert('Attention ! Pas plus de 5 images à la fois !');
		}

		currentNbFile = data.media.length;
	}

	function changeFileName(file, iterator) {
		let oldFileName = file.name;
		let fileExtension = oldFileName.split('.').pop();
		let currentDate = new Date();
		let fileName =
			currentDate.getFullYear().toString() +
			currentDate.getMonth().toString() +
			currentDate.getDate().toString() +
			currentDate.getHours().toString() +
			currentDate.getMinutes().toString() +
			currentDate.getSeconds().toString() +
			iterator;
		return new File([file], fileName + '.' + fileExtension, { type: file.type });
	}
</script>

<MainTitle title={data.nom} />
{#if isConnected}
	<SendMediaForm onClick={SendFile} />
{/if}
<LoadFile bind:dataLoading={isLoadData} bind:nbFile={data.media.length} bind:oldNbFile={currentNbFile} />
<AllMedia bind:media={data.media} />
